module.exports = __webpack_public_path__ + "img/image4.b3ba7c05.png";